export const LINKEDIN_URL = "https://www.linkedin.com/in/ayushkaushik";
export const DEVTO_URL = "https://dev.to/ayushkaushik";
export const COPYRIGHT = "Ayush Kaushik © 2025";
export const GITHUB_URL = "https://github.com/Ayush-Kaushik";